<template>
  <div class="home">
    <!-- Intégration du composant header qui est toujours visible -->
    <HeaderComponent />

    <!-- Contenu de la page d'accueil -->
    <div class="container mt-5">
      <h1>Bienvenue sur la page d'accueil</h1>
      <!-- Autres éléments propres à la homepage -->
    </div>
  </div>
</template>

<script>
import HeaderComponent from '@/components/HeaderComponent.vue';

export default {
  name: 'HomePage',
  components: {
    HeaderComponent
  },
  mounted() {
    this.checkAuthAndRedirect();
  },
  methods: {
    checkAuthAndRedirect() {
      // Vérifier si l'utilisateur est connecté
      const token = localStorage.getItem('access_token');
      if (token) {
        // Si connecté, rediriger vers la page Accueil
        this.$router.push('/accueil');
      }
    }
  }
};
</script>

<style scoped>

</style>
